module.exports = __webpack_public_path__ + "img/cdc_prjweb.81cbc0e8.png";